import React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';
import { cn } from '../../lib/utils';

interface SwitchProps {
    checked: boolean;
    onCheckedChange: (checked: boolean) => void;
    label?: string;
    description?: string;
    disabled?: boolean;
    className?: string;
}

export const Switch: React.FC<SwitchProps> = ({
    checked,
    onCheckedChange,
    label,
    description,
    disabled = false,
    className,
}) => {
    return (
        <div className={cn('flex items-start justify-between gap-4', className)}>
            {(label || description) && (
                <div className="min-w-0 flex-1">
                    <div className="flex flex-col gap-1">
                        {label && <span className="text-sm font-medium leading-5 text-surface-700">{label}</span>}
                        {description && <span className="text-xs leading-4 text-surface-500">{description}</span>}
                    </div>
                </div>
            )}
            <SwitchPrimitive.Root
                checked={checked}
                onCheckedChange={onCheckedChange}
                disabled={disabled}
                className={cn(
                    'shrink-0',
                    'w-11 h-6 rounded-full relative transition-colors duration-200',
                    'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2',
                    checked ? 'bg-gradient-to-r from-primary-500 to-primary-600' : 'bg-surface-300',
                    disabled && 'opacity-50 cursor-not-allowed'
                )}
            >
                <SwitchPrimitive.Thumb
                    className={cn(
                        'block w-5 h-5 bg-white rounded-full shadow-lg transition-transform duration-200',
                        'translate-x-0.5',
                        checked && 'translate-x-[22px]'
                    )}
                />
            </SwitchPrimitive.Root>
        </div>
    );
};
